import { IDateRange } from '@/utils/interfaces/DateRangeInterface';
import { lastFifteenDays } from '@/utils/helpers/DateHelper';
import { toQueryString } from '@/utils/parsers/QueryString';
import { ChannelModel } from '../../channel/models/ChannelModel';
import { StoreModel } from '../../store/models/StoreModel';

export class DashboardBaseFilterModel {
    id?:string|number = undefined
    description:string = ''
    date:IDateRange = initialDate()
    dateSubmitted:IDateRange = initialDate()
    channelListWrapper: ChannelModel[] = []
    storeListWrapper: StoreModel[] = []
    channelList: number[] = []
    storeList: number[] = []

    constructor(b?:Partial<DashboardBaseFilterModel>) {
        this.date.start = initialDate().start
        this.date.end = initialDate().end
        this.dateSubmitted.start = initialDate().start
        this.dateSubmitted.end = initialDate().end
        
        Object.assign(this, b)

        this._parseChannelListWrapperInfo();
        this._parseStoreListWrapperInfo();
    }

    hasChannelList():boolean {
        return !!this.channelListWrapper.length
    }

    getChannelListDescription():string {
        return this.channelListWrapper.map((c) => {
            return c.name
        }).join(',').replace(/,/g, ', ')       
    }

    getStoreListDescription():string {
        return this.storeListWrapper.map((s) => {
            return s.name
        }).join(',').replace(/,/g, ', ')
    }

    hasStoreList():boolean {
        return !!this.storeListWrapper.length
    }

    hasDate():boolean {
        return !!this.date && !!this.date.start && !!this.date.end
    }

    fillDateWhenEmpty():void {
        if (!this.hasDate()) {
            this.updatesToInitialState()
        }
    }

    updatesToInitialState():void {
        this.date = initialDate()
    }

    updatesFilterSubmitted():void {
        this.dateSubmitted.start = this.date.start
        this.dateSubmitted.end = this.date.end
        this.channelListWrapper = this.channelListWrapper || []
        this.storeListWrapper = this.storeListWrapper || []
    }

    updatesFilterSubmittedWith(filter: DashboardBaseFilterModel):void {
        this.dateSubmitted.start = filter.date.start
        this.dateSubmitted.end = filter.date.end
        this.channelListWrapper = filter.channelListWrapper || []
        this.storeListWrapper = filter.storeListWrapper || []
    }

    toQueryString():string {
        const startDate = this.date ? this.date.start as Date : null
        const endDate = this.date ? this.date.end as Date : null

        const tmp = {
            ...this,
            date: undefined,            
            dateSubmitted: undefined,
            startDate: startDate ? startDate.toISOString() : undefined,
            endDate: endDate ? endDate.toISOString() : undefined,
            channelListWrapper: undefined,
            storeListWrapper: undefined,
            channelList: this.channelListWrapper.map((c) => c.id).join(','),
            storeList: this.storeListWrapper.map((s) => s.id).join(','),
        }

        return toQueryString(tmp)
    }

    private _parseChannelListWrapperInfo():void {
        this.channelList = this.channelListWrapper.map((c) => Number(c.id))
    }

    private _parseStoreListWrapperInfo():void {
        this.storeList = this.storeListWrapper.map((s) => Number(s.id))
    }
}

function initialDate():IDateRange {
    return {
        start: lastFifteenDays(),
        end: new Date(),
    }
}

export interface IDashboardFilter {
    hasDate():boolean
    fillDateWhenEmpty():void
    updatesToInitialState():void
    updatesFilterSubmitted():void
    toQueryString():string
}
